export default __webpack_public_path__ + "static/media/two.34a21b89.png";